export const reefsRouteLinks = {
    root: "/reefs",
    create: "/reefs/create",
    hostedScriptsRollout: "/reefs/hosted-scripts-rollout",
    reef: (id: string) => ({
        root: `/reefs/${id}`,
        tasks: `/reefs/${id}/tasks`,
        hostedScripts: `/reefs/${id}/hosted-scripts`
    })
};
